import * as allDirectives from '@bv/directives';
import { toKebabCase } from '@bv/utils';

import type { App, Directive, Plugin as VuePlugin } from 'vue';

const toPlugin = (): VuePlugin<[]> => {
  return {
    install: (app: App, _?: Record<string, any>) => {
      Object.entries(allDirectives).forEach(([name, directive]) => {
        const directiveName: string = toKebabCase(name);
        app.directive(directiveName, directive as Directive);
      });
    },
  };
};

export const directives = toPlugin();

export default directives;
